import {useState} from "react";
import SearchAndChoose from "../../../batglede/components/SearchAndChoose";

export default function ArticleQuizEditor({valueRef, part, setPart}){
	const [isChoosingVideo, setIsChoosingVideo] = useState(false);

	const handleVideoChange = (videoId)=>{
		valueRef.current.value = videoId;
		setIsChoosingVideo(false);
	}

	return(<>
		<button type={"button"} onClick={()=>setIsChoosingVideo(!isChoosingVideo)}>Velg quiz</button>
		{isChoosingVideo&& <SearchAndChoose searchIn={'quiz'} searchBy={'name'} chooseFunction={handleVideoChange}  setIsOpen={setIsChoosingVideo} />}
		<br/>
	</>)
}